// extracted by mini-css-extract-plugin
export default {"error-text":"z-input-error-text_error-text__nPWIs"};